import { render, staticRenderFns } from "./CustomerOverview.vue?vue&type=template&id=027681e3&scoped=true&"
import script from "./CustomerOverview.vue?vue&type=script&lang=js&"
export * from "./CustomerOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027681e3",
  null
  
)

export default component.exports